import { playerTypes } from '../constants';

export const closePlayer = () => ({
  type: playerTypes.CLOSE_PLAYER
});

export const openPlayer = () => ({
  type: playerTypes.OPEN_PLAYER
});

export const setPlayerLoaded = () => ({
  type: playerTypes.SET_PLAYER_LOADED
});

export const resetPlayerLoaded = () => ({
  type: playerTypes.RESET_PLAYER_LOADED
});

export const toggleUrlMismatch = (urlMismatch) => ({
  type: playerTypes.TOGGLE_URL_MISMATCH,
  urlMismatch
});

export const setPlayerURL = () => ({
  type: playerTypes.SET_PLAYER_URL,
  endpoint: 'v1/constants/extras/',
  method: 'get'
});

export const fetchClassDetails = (uid) => ({
  type: playerTypes.FETCH_CLASS,
  endpoint: `v1/uplus/classes/${uid}/details/`,
  method: 'get',
  uid
});

export const fetchObjectType = () => ({
  type: playerTypes.SET_OBJECT_TYPE,
  endpoint: 'v1/common/actions/object_types/',
  method: 'get'
});

export const setShowReferral = (classUID) => ({
  type: playerTypes.SET_SHOW_REFERRAL,
  classUID
});
